import { OfferData } from '../../../core/domain/offerData.model'
import OfferService from '../../../core/services/offer.service'
import { LifecyclePresenter } from '../../_components/ConnectComponent'
import { AdobeEventManager } from '../../_utils/adobeAnalytics'
import { dataLayer } from '../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { redirectionProvider } from '../CalculatorRedirection.provider'
import { TypeOfGoodsRaw, TypeOfGoodsValues, View } from './TypeOfGoods.view'

export class TypeOfGoodsPresenter implements LifecyclePresenter<View> {
  private view!: TypeOfGoodsRaw
  private stepPageName: string = 'transporting-goods'
  private stepPageNumber: number = 4
  protected offer: OfferData

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    dataLayer.page.category.applicationStep = 'step4-typeOfGoods'
    AdobeEventManager.track('calc_step')

    await this.getOfferDocument()

    this.view.setInitialValues(
      {
        transRemoval: this.offer.transRemoval ? this.offer.transRemoval : 10,
        transTheft: this.offer.transTheft ? this.offer.transTheft : 10,
        liability: this.offer.liability ? this.offer.liability : 'OR',
        theftRadioValue: this.offer.transTheft > 0 ? 'true' : 'false',
        removalRadioValue: this.offer.transRemoval > 0 ? 'true' : 'false',
      },
      this.offer.progressMask[6] === '1',
    )
  }

  getOfferDocument = async () => {
    try {
      this.offer = await OfferService.getOfferData()
    } catch (error) {
      console.log(error)
    }
  }

  onContinue = async (formValues: TypeOfGoodsValues) => {
    this.manageLastVisitedStep(this.stepPageNumber)

    const offer = this.setFormValues(formValues)

    OfferService.saveOfferData(offer).then(() => this.goToNextStep())
  }

  setFormValues = (formValues: TypeOfGoodsValues) => {
    return Object.assign(this.offer, {
      transRemoval:
        formValues.removalRadioValue === 'true' ? formValues.transRemoval : 0,
      transTheft:
        formValues.theftRadioValue === 'true' ? formValues.transTheft : 0,
      liability: formValues.liability,
    })
  }

  goToNextStep = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToFollowingStep(
        this.stepPageName,
        this.offer,
      ),
    )
  }

  saveAndRedirect = (formValues: TypeOfGoodsValues) => {
    this.offer = Object.assign(this.offer, { ...formValues })
    OfferService.saveOfferData(this.offer).then(() =>
      this.view.props.history.push('/contact-me'),
    )
  }

  onBackClick = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToPreviousStep(this.stepPageName, this.offer),
    )
  }

  manageLastVisitedStep = (currentStep: number) => {
    let progress = this.offer.progressMask
    this.offer.progressMask =
      progress.substr(0, currentStep - 1) + '1' + progress.substr(currentStep)
  }
}
